import React from 'react';
import './style.css';
import SteamIcon from '../../steam_icon.png';
import Draggable from 'react-draggable'; // Both at the same time
import { Resizable, ResizableBox } from 'react-resizable';

class Aba extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        open: !this.props.open,
        drag: false
    }
  }
  Close(){
    this.setState(state => ({
        open: !state.open
    }));
  }
  render(){
    return <div>
    <Draggable handle=".header">
      <div className={"aba "+ (this.state.open ? 'open ' : 'closed ') + (this.state.drag ? 'drag' : '')}>
          <div className="header">
            <span className="title">
            <img src={SteamIcon}/>
            { this.props.title }
            </span>    
            <span className="close" onClick={() => { this.Close() }}> 
            <i className="fas fa-times"></i>
            </span>

          </div>
          <div className="data">
              { <this.props.data/> }
          </div>
      </div>
      
      </Draggable>
    
    </div>
  };
}

export default Aba;